import React from 'react';

import isNumber from 'lodash/isNumber';

import { makeStyles, Tab as UITab, Tabs as UITabs } from '@gogame/components';
import { useNumberFormat } from '@gogame/intl-ts';

import { useConceptFamiliesCount } from 'scenes/Gallery/GalleryPage/ConceptFamilies/ConceptFamiliesDataTable/ConceptFamiliesDataTableContext';
import { useConceptsCount } from 'scenes/Gallery/GalleryPage/Concepts/ConceptsDataTable/ConceptsDataTableContext';
import { useCreativesCount } from 'scenes/Gallery/GalleryPage/Creatives/CreativesDataTable/CreativesDataTableContext';
import {
  TAB_CONCEPTS,
  TAB_CREATIVES,
  TAB_CONCEPT_FAMILIES,
} from 'scenes/Gallery/GalleryPage/constants';
import { useGalleryPermissions } from 'scenes/Gallery/GalleryPage/hooks';

const useStyles = makeStyles(() => ({
  root: {
    margin: '-16px',
  },
  tab: {
    height: 64,
  },
}));

const TabLabel = ({ name, count }) => {
  const format = useNumberFormat();
  return `${name}${isNumber(count) ? ` (${format(count)})` : ''}`;
};

const Tabs = ({ value, onChange }) => {
  const classes = useStyles();
  const { isAllowConceptFamilies } = useGalleryPermissions();

  const conceptFamilyCount = useConceptFamiliesCount();
  const conceptCount = useConceptsCount();
  const creativeCount = useCreativesCount();

  return (
    <div className={classes.root}>
      <UITabs value={value} onChange={onChange}>
        <UITab
          key={TAB_CONCEPTS}
          value={TAB_CONCEPTS}
          label={<TabLabel name={'Concepts'} count={conceptCount} />}
          data-cy-label={'Concepts'}
          className={classes.tab}
        />
        <UITab
          key={TAB_CREATIVES}
          value={TAB_CREATIVES}
          label={<TabLabel name={'Creatives'} count={creativeCount} />}
          data-cy-label={'Creatives'}
          className={classes.tab}
        />

        {isAllowConceptFamilies && (
          <UITab
            key={TAB_CONCEPT_FAMILIES}
            value={TAB_CONCEPT_FAMILIES}
            label={
              <TabLabel name={'Concept Families'} count={conceptFamilyCount} />
            }
            data-cy-label={'Concept Families'}
            className={classes.tab}
          />
        )}
      </UITabs>
    </div>
  );
};
export default Tabs;
